export default "__VITE_ASSET__CGdyLGdI__"